// lodash
import _startsWith from 'lodash/startsWith';
import _includes from 'lodash/includes';
import { EMAIL_REGEX, SPECIAL_FORMAT_DIAL_CODES, LOWEST_VALID_PHONE_NUMBER, VALID_NUMBER_WITHOUT_ZERO_IN_BEGINNING, VALID_NUMBER_WITH_ZERO_IN_BEGINNING } from "../../constants/index.js";
/**
 * determines if the email is valid or not based on RFC-2822 standard
 * @param {string} email
 * @returns {boolean}
 */
export function isEmail(email) {
  return EMAIL_REGEX.test(String(email).toLowerCase());
}

/**
 * check if the phone number format is valid
 * @param {string} dialCode
 * @param {string} phoneNumber
 */
export function isValidPhoneNumber(dialCode, phoneNumber) {
  var isStartsWithZero = _startsWith(phoneNumber, '0');
  var isSpecialDialCode = _includes(SPECIAL_FORMAT_DIAL_CODES, dialCode);
  var isValid = !!phoneNumber && phoneNumber.length > LOWEST_VALID_PHONE_NUMBER;
  if (isSpecialDialCode) {
    return isValid && (isStartsWithZero && phoneNumber.length === VALID_NUMBER_WITH_ZERO_IN_BEGINNING || !isStartsWithZero && phoneNumber.length === VALID_NUMBER_WITHOUT_ZERO_IN_BEGINNING);
  }
  return isValid;
}

/**
 * is defined
 * @param arg
 */
export function isDefined(arg) {
  return typeof arg !== 'undefined';
}